<section class="py-24 relative overflow-hidden">
	<!-- Background Gradient -->
	<div
		class="absolute inset-0 bg-gradient-to-br from-[#0a0a0f] via-[#1a0b2e] to-[#0a0a0f]"
	></div>

	<!-- Animated Glows -->
	<div
		class="absolute top-0 left-1/4 w-[500px] h-[500px] bg-primary/20 blur-[100px] rounded-full animate-pulse-glow"
	></div>
	<div
		class="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-neon-cyan/10 blur-[100px] rounded-full animate-float"
	></div>

	<!-- Grid Overlay -->
	<div
		class="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:50px_50px] [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]"
	></div>

	<div class="container mx-auto px-6 max-w-4xl text-center relative z-10">
		<h2
			class="text-4xl md:text-6xl font-bold mb-8 text-white leading-tight"
		>
			Ready to Build Your <br />
			<span
				class="text-transparent bg-clip-text bg-gradient-to-r from-primary via-white to-neon-cyan"
				>Operating System?</span
			>
		</h2>
		<p
			class="text-xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed"
		>
			Join forward-thinking teams building complete, production-ready
			systems in days, not months.
		</p>

		<div class="flex flex-col sm:flex-row gap-6 justify-center mb-16">
			<a
				href="/start"
				class="group relative px-8 py-4 bg-primary text-white text-lg font-bold rounded-xl overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_40px_rgba(124,58,237,0.5)]"
			>
				<div
					class="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"
				></div>
				<span class="relative">Start Building Now</span>
			</a>
			<a
				href="/demo"
				class="px-8 py-4 rounded-xl border border-white/10 bg-white/5 text-lg font-semibold text-white backdrop-blur-sm transition-all hover:bg-white/10 hover:border-white/20 hover:text-white"
			>
				Book a Demo
			</a>
		</div>

		<div class="pt-12 border-t border-white/5">
			<p
				class="text-sm text-gray-400 mb-6 uppercase tracking-widest font-mono"
			>
				Professional Grade Platform
			</p>
			<div
				class="flex flex-wrap justify-center gap-8 md:gap-16 text-sm text-gray-300"
			>
				<div class="flex items-center gap-3">
					<span class="text-neon-cyan text-lg">✓</span>
					<span>24/7 Automated Support</span>
				</div>
				<div class="flex items-center gap-3">
					<span class="text-neon-cyan text-lg">✓</span>
					<span>SOC2 Compliance Ready</span>
				</div>
				<div class="flex items-center gap-3">
					<span class="text-neon-cyan text-lg">✓</span>
					<span>99.99% Uptime SLA</span>
				</div>
			</div>
		</div>
	</div>
</section>
